import React, { useContext } from "react";
import {
  Grid,
  Divider,
  TextField,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@material-ui/core";

// Contexts
import OrderContext from "../../../../../../context/orders/v1/OrdersContext";

const TrackingForm = (props) => {
  const { classes } = props;

  const { modalValues, setValues } = useContext(OrderContext);

  const handleChange = (e) => {
    const id = e.target.id;
    const value =
      e.target.id === "notify_customer" ? e.target.checked : e.target.value;

    let new_values = Object.assign({}, modalValues);

    new_values[id] = value;

    setValues(new_values);
  };

  return (
    <form>
      <Divider className={classes.contentDivider} orientation="horizontal" />
      <Typography variant="body2" className={classes.title}>
        TRACKING INFORMATION{" "}
      </Typography>
      <Grid container direction="row">
        <Grid item xs={6}>
          <TextField
            fullWidth
            margin="dense"
            variant="outlined"
            className={classes.textField}
            label="Tracking number"
            id="tracking_number"
            value={
              modalValues.tracking_number ? modalValues.tracking_number : ""
            }
            onChange={handleChange}
          />{" "}
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            margin="dense"
            variant="outlined"
            select
            SelectProps={{
              native: true,
            }}
            className={classes.textField}
            label="Shipping carrier"
            id="tracking_company"
            name="tracking_company"
            value={
              modalValues.tracking_company ? modalValues.tracking_company : ""
            }
            onChange={handleChange}
          >
            <option value="China Post"> China Post </option>{" "}
          </TextField>{" "}
        </Grid>{" "}
      </Grid>
      <Divider className={classes.contentDivider} orientation="horizontal" />
      <Typography variant="body2" className={classes.title}>
        NOTIFY CUSTOMER OF SHIPMENT{" "}
      </Typography>
      <FormControlLabel
        control={
          <Checkbox
            color="primary"
            id="notify_customer"
            checked={
              modalValues.notify_customer ? modalValues.notify_customer : false
            }
            onChange={handleChange}
          />
        }
        label={
          <Typography variant="body2" className={classes.headerBox}>
            Send shipment details to your customer now{" "}
          </Typography>
        }
      />{" "}
    </form>
  );
};

export default TrackingForm;
